module.exports = __webpack_public_path__ + "static/media/piggyPlane.36266299.gif";